import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VisualBreak1 } from './components/VisualBreak1';
import { Technology } from './components/Technology';
import { DualLaser } from './components/DualLaser';
import { VisualBreak2 } from './components/VisualBreak2';
import { Environment } from './components/Environment';
import { Service } from './components/Service';
import { VisualBreak3 } from './components/VisualBreak3';
import { WhyUs } from './components/WhyUs';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // SEO: Page title
    document.title = 'Dispel Your Tattoo – Détatouage Laser Professionnel à Martigny, Valais';
    // SEO: Meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Dispel Your Tattoo : spécialiste du détatouage laser à Martigny en Valais. Technologies picoseconde et Q-Switched pour un effacement sûr, précis et adapté à chaque type de peau. Consultation personnalisée.';
    // SEO: Language
    document.documentElement.lang = 'fr';
    // SEO: Viewport (ensure it exists)
    let viewport = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(viewport);
    }
    // SEO: Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://www.dispelyourtattoo.ch';
    // SEO: Open Graph tags
    const ogTags: Record<string, string> = {
      'og:title': 'Dispel Your Tattoo – Détatouage Laser Professionnel à Martigny',
      'og:description': 'Spécialiste du détatouage laser en Valais. Technologies picoseconde et Q-Switched pour un effacement sûr et précis.',
      'og:type': 'website',
      'og:url': 'https://www.dispelyourtattoo.ch',
      'og:locale': 'fr_CH',
      'og:site_name': 'Dispel Your Tattoo',
      'og:image': 'https://cdn.magicpatterns.com/uploads/c7DtgUV4minxineBKqyaMP/IMG_2681-PROOF-THOMAS-MASOTTI.jpg'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
    // SEO: JSON-LD Structured Data
    const schemaId = 'dispel-schema-ld';
    let existingSchema = document.getElementById(schemaId);
    if (existingSchema) existingSchema.remove();
    const schema = document.createElement('script');
    schema.id = schemaId;
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'LocalBusiness',
        '@id': 'https://www.dispelyourtattoo.ch/#business',
        name: 'Dispel Your Tattoo',
        description: 'Studio spécialisé en détatouage laser à Martigny, Valais. Technologies picoseconde et Q-Switched.',
        url: 'https://www.dispelyourtattoo.ch',
        image: 'https://cdn.magicpatterns.com/uploads/c7DtgUV4minxineBKqyaMP/IMG_2681-PROOF-THOMAS-MASOTTI.jpg',
        telephone: '+41000000000',
        email: 'hello@dispelyourtattoo.ch',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Martigny',
          addressRegion: 'Valais',
          addressCountry: 'CH'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 46.0986,
          longitude: 7.0728
        },
        priceRange: '$$',
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00'
        },
        areaServed: {
          '@type': 'Place',
          name: 'Valais, Suisse'
        },
        sameAs: []
      }, {
        '@type': 'Service',
        '@id': 'https://www.dispelyourtattoo.ch/#service',
        name: 'Détatouage Laser',
        description: 'Effacement professionnel de tatouages par laser picoseconde et Q-Switched à Martigny.',
        provider: {
          '@id': 'https://www.dispelyourtattoo.ch/#business'
        },
        areaServed: {
          '@type': 'Place',
          name: 'Valais, Suisse'
        },
        serviceType: 'Détatouage laser'
      }, {
        '@type': 'WebSite',
        '@id': 'https://www.dispelyourtattoo.ch/#website',
        url: 'https://www.dispelyourtattoo.ch',
        name: 'Dispel Your Tattoo',
        inLanguage: 'fr-CH',
        publisher: {
          '@id': 'https://www.dispelyourtattoo.ch/#business'
        }
      }]
    });
    document.head.appendChild(schema);
    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-light selection:bg-brand-light selection:text-brand-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <VisualBreak1 data-id="element-4" />
        <Technology data-id="element-5" />
        <DualLaser data-id="element-6" />
        <VisualBreak2 data-id="element-7" />
        <Environment data-id="element-8" />
        <Service data-id="element-9" />
        <VisualBreak3 data-id="element-10" />
        <WhyUs data-id="element-11" />
        <CTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}